export const MARQUEE_ITEM_PROPS = {
  active: false,
  item: '',
};

export const MARQUEE_PROPS = {
  items: [],
  tick: 0,
};
